import { encodeInvalidCharacters, handleApiError } from '../../common/util';
import { IWorkshopVehicleDetails } from '../../models/dms/workshopVehicle.model';
import axiosDmsInstance from './axiosDmsInstance';

export const getWorkshopVehicleDetails = async (registrationNumber: string) => {
  try {
    const url = `/api/workshop/vehicle/v1/${encodeInvalidCharacters(registrationNumber)}/detail`;
    let params = {} as any;

    const response = await axiosDmsInstance.get<IWorkshopVehicleDetails>(`${url}`, {
      params,
    });

    return response.data;
  } catch (err: any) {
    return handleApiError('getWorkshopVehicleDetails', err);
  }
};
